<template>
  <v-menu
    bottom
    left
    class="ml-2 custom-menu"
  >
    <template slot="activator">
      <v-btn
        class="ma-0 ml-0 pa-0"
        flat
        icon
        dark
        color="sz_violet"
        @click="openModal()"
      >
        <v-icon>more_vert</v-icon>
      </v-btn>
    </template>
    <v-list
      v-if="$vuetify.breakpoint.smAndUp"
      class="list-custom"
    >
      <template v-for="(item, i) in items">
        <v-list-tile
          v-if="item.url != null && familyId != null"
          :key="i"
          :href="familyUrl(familyId).href"
        >
          <v-list-tile-title>{{ item.text }}</v-list-tile-title>
        </v-list-tile>
      </template>
      <template v-for="(item, i) in items">
        <v-list-tile
          v-if="item.url != null && warehouseId != null"
          :key="i"
          :href="warehouseUrl(warehouseId).href"
        >
          <v-list-tile-title>{{ item.text }}</v-list-tile-title>
        </v-list-tile>
      </template>
      <template v-for="(item, i) in items">
        <v-list-tile
          v-if="item.url == null"
          :key="i"
          @click="emitActionId(item)"
        >
          <v-list-tile-title>{{ item.text }}</v-list-tile-title>
        </v-list-tile>
      </template>
    </v-list>
    <v-dialog
      v-else
      v-model="dialog"
      fullscreen
    >
      <v-card>
        <v-card-title class="card-title">
          <v-layout>
            <v-flex xs11>
              <p class="text-xs-center display-3 sz_grafit--text ma-0 mt-1">
                {{ $t('message.more') }}
              </p>
            </v-flex>
            <v-flex xs1>
              <v-icon
                large
                class="clickable sz_grafit--text ma-0"
                @click="closeDialog()"
              >
                clear
              </v-icon>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-list>
          <div
            v-for="(item, i) in items"
            :key="i"
            @click="emitActionId(item)"
          >
            <v-list-tile>
              <v-list-tile-title class="list-text">
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile>
            <v-divider class="mx-2" />
          </div>
        </v-list>
      </v-card>
    </v-dialog>
  </v-menu>
</template>

<script>
import getRouterUrl from '@/mixins/getRouterUrl';
export default {
    name: 'ActionMenu',
    mixins: [getRouterUrl],
    props: ['items', 'familyId', 'warehouseId'],
    data () {
        return {
            dialog: false
        };
    },
    methods: {
        openModal () {
            if (this.$vuetify.breakpoint.xsOnly) {
                this.dialog = true;
            }
        },
        closeDialog () {
            this.dialog = false;
        },
        emitActionId (item) {
            this.$emit('clicked-item', item.id);
            this.closeDialog();
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../../../assets/css/variables';

.menuable__content__active {
  box-shadow: 0 2px 6px 1px rgba(195, 192, 192, 0.44);
  border: 0;
  margin-top: 36px;
}
.v-menu__activator.v-menu__activator--active {
  button.v-btn--icon {
    box-shadow: 0 2px 6px 1px rgba(195, 192, 192, 0.44) !important;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    border-radius: 0;
  }
  .v-btn--icon:before {
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    border-radius: 0;
    background-color: #ffffff;
  }
  .v-btn__content .v-icon {
    color: $sz_violet;
  }
}
.v-list__tile__title {
  color: $sz_violet;
}
.list-text {
  font-size: 16px;
  font-weight: bold;
  line-height: 31px;
}
.card-title {
  background-color: $sz_background_light;
}
</style>
